// 返回8位随机字符串
export default function generateID() {
  return Math.random().toString(36).slice(-9);
}

export function generateAnimationId() {
  return parseInt(Math.random().toString().slice(-8));
}
